import { lazyStories } from '@w/ui/storybook'

const FormGenerator = lazyStories(() => import('./form-generator.stories'))
const UniCard = lazyStories(() => import('./uni-card.stories'))

export default {
  FormGenerator: {
    BasicForm: FormGenerator.BasicForm,
    WithDefaults: FormGenerator.WithDefaults,
    NestedObjects: FormGenerator.NestedObjects,
    DiscriminatedUnion: FormGenerator.DiscriminatedUnion,
    NullableFields: FormGenerator.NullableFields,
    RegularUnion: FormGenerator.RegularUnion,
    ComplexArrayItems: FormGenerator.ComplexArrayItems,
    FileUpload: FormGenerator.FileUpload,
    FileWithConstraints: FormGenerator.FileWithConstraints,
    FileArray: FormGenerator.FileArray,
    UserSelect: FormGenerator.UserSelect,
    UserSelectWithDefault: FormGenerator.UserSelectWithDefault,
    ResourceSelect: FormGenerator.ResourceSelect,
  },
  UniCard: { AllVariants: UniCard.AllVariants },
}
